import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Fontawesome from 'react-fontawesome';
import classNames from 'classnames';

import 'app/assets/stylesheets/academia_components/buttons.scss';
import {
  followUser,
  unfollowUser,
  showSignupToFollow,
} from 'js/profiles/setUpLeftSidebarButtons';

const SocialButton = ({ icon, children, className, textOnly, ...props }) => {
  const buttonProps = {
    ...props,
    className: classNames(
      'wp-social-button',
      {
        'text-only': textOnly,
      },
      className,
    ),
  };

  return (
    <button {...buttonProps}>
      <span className="wp-social-button-content">
        {!!icon && <Fontawesome name={icon} />}
        <span>{children}</span>
      </span>
    </button>
  );
};

// shared proptypes
const proptypes = {
  className: PropTypes.string,
  textOnly: PropTypes.bool,
};

export const FollowButton = ({
  userId,
  source,
  firstName,
  className = '',
  following = false,
  ...props
}) => {
  const [isFollowing, setIsFollowing] = useState(following);

  useEffect(() => {
    setIsFollowing(following);
  }, [following]);

  const handleFollow = async (e) => {
    e.preventDefault();
    const loggedIn = Aedu.User.current && !Aedu.User.current.unconfirmed;
    if (!loggedIn) {
      showSignupToFollow(String(userId), firstName);
      return;
    }
    const res = await followUser(String(userId), source, '');
    if (res.ok) setIsFollowing(true);
  };

  const handleUnfollow = async (e) => {
    e.preventDefault();
    if (!Aedu.User.current || Aedu.User.current.unconfirmed) return;
    const res = await unfollowUser(String(userId));
    if (res.ok) setIsFollowing(false);
  };

  return (
    <span className="wp-social-button__container">
      <SocialButton
        style={isFollowing ? {} : { display: 'none' }}
        data-unfollow-user-id={userId}
        icon="check"
        {...props}
        onClick={handleUnfollow}
        className={'follow ' + className}
      >
        Following
      </SocialButton>
      <SocialButton
        style={isFollowing ? { display: 'none' } : {}}
        data-follow-user-id={userId}
        data-follow-user-source={source}
        data-follow-user-fname={firstName}
        icon="plus"
        {...props}
        onClick={handleFollow}
        className={'follow ' + className}
      >
        Follow
      </SocialButton>
    </span>
  );
};

FollowButton.propTypes = {
  ...proptypes,
  userId: PropTypes.number.isRequired,
  source: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
};

export const MessageButton = ({ userId, className = '', ...props }) => (
  <span className="wp-social-button__container">
    <SocialButton
      data-send-message
      data-recipient-id={userId}
      icon="comment"
      {...props}
      className={'message ' + className}
    >
      Message
    </SocialButton>
  </span>
);
MessageButton.propTypes = {
  ...proptypes,
  userId: PropTypes.number.isRequired,
};
